import React from "react";
import MuiTab from "@mui/material/Tab";
import MuiTabs from "@mui/material/Tabs";
import { getClassName, prettifyLargeCount } from "@sscs/utils";
import DotSeparator from "../DotSeparator/DotSeparator";
import styles from "./tabs.module.scss";
const Tab = ({ count, label, ...rest }) => {
    if (count === undefined) {
        return React.createElement(MuiTab, { ...rest, label: label });
    }
    return (React.createElement(MuiTab, { ...rest, label: React.createElement("span", { className: styles["label-with-count"] },
            label,
            React.createElement(DotSeparator, null),
            React.createElement("span", { className: getClassName(styles.count, {
                    [styles["count-zero"]]: count === 0,
                }) }, prettifyLargeCount(count))) }));
};
/**
 * Underline tabs for switching between views of the same subject (an artifact's Overview / Findings /
 * Dependencies). `Tabs.Tabs` is the strip, `Tabs.Tab` a single tab. Appearance lives in the theme
 * (`Theme/overrides/tabs.ts`). Both are controlled: the parent owns `value` and updates it from `onChange`.
 * A `Tabs.Tab` with a `count` renders `label ◦ count` — the count follows the tab ink when selected and
 * greys out at zero.
 */
export default {
    Tabs: MuiTabs,
    Tab,
};
//# sourceMappingURL=Tabs.js.map